import React, { useState, useEffect } from 'react';
import { getSliders } from '../../api/services';
import './HeroSlider.css';

// Fallback slides using local images (used when DB has no sliders yet)
const FALLBACK_SLIDES = [
  {
    id: 1,
    image_url: '/images/slider/slide1.jpg',
    title: 'Transforming Outdoor Spaces',
    subtitle: 'Premium landscaping solutions for residential & commercial projects across Chhattisgarh',
  },
  {
    id: 2,
    image_url: '/images/slider/slide2.jpg',
    title: 'Elegant Garden Design',
    subtitle: 'Creating serene green environments that blend nature with architecture',
  },
  {
    id: 3,
    image_url: '/images/slider/slide3.jpg',
    title: 'Rooftop & Terrace Gardens',
    subtitle: 'Modern green spaces designed for urban living — functional and beautiful',
  },
  {
    id: 4,
    image_url: '/images/slider/slide4.jpg',
    title: 'Your Vision, Our Craftsmanship',
    subtitle: 'From concept to completion — we bring your landscaping dreams to life',
  },
];

function HeroSlider() {
  const [slides, setSlides]           = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loading, setLoading]         = useState(true);

  useEffect(() => {
    getSliders()
      .then((res) => {
        if (res.success && res.data && res.data.length > 0) {
          setSlides(res.data);
        } else {
          setSlides(FALLBACK_SLIDES);
        }
      })
      .catch(() => {
        setSlides(FALLBACK_SLIDES);
      })
      .finally(() => setLoading(false));
  }, []);

  // Auto-advance
  useEffect(() => {
    if (slides.length === 0) return;
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides]);

  const goToSlide = (index) => setCurrentSlide(index);
  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % slides.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);

  if (loading) {
    return (
      <section className="hero-slider hero-slider--loading">
        <div className="hero-slider__loader">
          <div className="hero-slider__loader-dot"></div>
          <div className="hero-slider__loader-dot"></div>
          <div className="hero-slider__loader-dot"></div>
        </div>
      </section>
    );
  }

  return (
    <section id="home" className="hero-slider">
      <div className="slider-container">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image_url})` }}
          >
            <div className="slide-overlay">
              <div className="container slide-content">
                {slide.title && (
                  <h1 className="slide-title">{slide.title}</h1>
                )}
                {slide.subtitle && (
                  <p className="slide-subtitle">{slide.subtitle}</p>
                )}
                <div className="slide-actions">
                  <a href="/services" className="btn-primary">Our Services</a>
                  <a href="/projects" className="btn-secondary">View Projects</a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {slides.length > 1 && (
        <>
          <button className="slider-btn prev" onClick={prevSlide} aria-label="Previous slide">
            ‹
          </button>
          <button className="slider-btn next" onClick={nextSlide} aria-label="Next slide">
            ›
          </button>

          <div className="slider-dots">
            {slides.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </>
      )}
    </section>
  );
}

export default HeroSlider;